import { createContext } from 'react';

export const ProductTypeContext = createContext();
